import { AddAccessGroupMembersModalContent } from "./AddAccessGroupMembersModalContent";
import { AddAccessGroupMemberDataProvider } from "./DataStoreContext/AddAccessGroupMembersDataContext";

export const AddAccessGroupMembersModal = () => (
  <AddAccessGroupMemberDataProvider>
    <AddAccessGroupMembersModalContent />
  </AddAccessGroupMemberDataProvider>
);
